export default __webpack_public_path__ + "static/media/HIMFG.9d265c1a.png";